module.exports = __webpack_public_path__ + "static/media/hole.c89a2875.gif";